import React from "react";
import "./App.css";

// component import
import Home from "./Components/Home/Home";
import Navbar from "./Components/Navbar/Navbar";
import Profile from "./Components/Backend/Profile";
import Devs from "./Components/Devs/Devs";
import Dev from "./Components/Devs/Dev";

// styles import
import { Routes, Route, useNavigate } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { useSelector } from "react-redux";
import ResetPassword from "./Components/Auth/ResetPassword";
import Settings from "./Components/Backend/Settings";
// import Project from "./Components/Devs/Project";
import ProtectedRoutes from "./Components/Home/ProtectedRoutes";
import VerifyEmail from "./Components/Auth/VerifyEmail";
import PageNotFound from "./Components/Home/PageNotFound";

function App() {
  return (
    <>
      <CssBaseline />
      <Navbar />
      <Routes>
        <Route path="*" element={<PageNotFound />} />
        <Route path="/" element={<Home />} />
        {/* <Route path="/api/reset-password/:token" element={<ResetPassword />} /> */}
        <Route path="/devs" element={<Devs />} />
        <Route path="/devs/:dev" element={<Dev />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />
        <Route path="verify-email/" element={<VerifyEmail />} />

        {/* <Route path="/devs/:dev/:project" element={<Project />} /> */}

        {/* <Route
          path="verify-email/"
          element={
            <ProtectedRoutes>
              <VerifyEmail />
            </ProtectedRoutes>
          }
        /> */}

        <Route
          path="/dev/dashboard"
          element={
            <ProtectedRoutes>
              <Profile />
            </ProtectedRoutes>
          }
        />

        <Route
          path="/dev/settings"
          element={
            <ProtectedRoutes>
              <Settings />
            </ProtectedRoutes>
          }
        />
        {/* <Route path="/dev/skills" element={<Profile />} />
        <Route path="/dev/projects" element={<Profile />} /> */}
      </Routes>
    </>
  );
}

export default App;
